module.exports = __webpack_public_path__ + "assets/error.4398ee95.svg";